export enum TransactionType {
	COLLECT_DAYCARE_REWARDS = 0,
	CHECKIN_DAYCARE = 1,
	CHECKOUT_DAYCARE = 2
}
